import { UseFormTrigger } from "react-hook-form";
import Button from "components/atoms/buttons/Button";
import MagnetCreateForm from "components/organisms/magnets/MagnetCreateForm";
import { ArrowRight } from "components/atoms/Icon";
import Loading from "components/atoms/Loading";
import FormTab from "components/atoms/forms/FormTab";
import MagnetDetailsForm from "components/organisms/magnets/MagnetDetailsForm";

type CreateMagnetProps = {
  loading: boolean;
  currentStep: number;
  handleSetFormStep: (step: string) => void;
  handleFormSubmit: any;
  trigger: UseFormTrigger<CreateUpdateMagnetFormType>;
};

export default function CreateMagnet({
  loading,
  currentStep,
  handleSetFormStep,
  handleFormSubmit,
  trigger,
}: CreateMagnetProps) {
  const getForm = (step: Number) => {
    switch (step) {
      case 0:
        return <MagnetCreateForm />;
      case 1:
        return <MagnetDetailsForm />;
      default:
        return <MagnetCreateForm />;
    }
  };

  const handleValidationAndSetFormStep = async (step: string) => {
    if (await trigger()) {
      handleSetFormStep(step);
    }
  };

  return (
    <>
      <div className="mt-8 font-sora">
        {loading && <Loading />}
        <div className="main-container flex  min-h-[82vh] flex-col">
          <div>
            <div className="main-container">
              <div className="mb-5 flex items-center font-sora text-4xl font-semibold text-white 2xl:text-5xl">
                <h1>Create New Magnet</h1>
              </div>
              {/* Form Tabs */}
              <div className="flex gap-5">
                <FormTab
                  label="Creation Details"
                  isActive={currentStep === 0}
                  handleOnClick={() => handleValidationAndSetFormStep("0")}
                />

                <FormTab
                  label="Magnet Details"
                  isActive={currentStep === 1}
                  handleOnClick={() => handleValidationAndSetFormStep("1")}
                />
              </div>

              {/* Forms */}
              <div className="mt-4">{getForm(currentStep)}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full justify-end space-x-2 px-24 py-3 shadow-2xl">
        <Button
          text={currentStep === 1 ? "CREATE MAGNET" : "NEXT"}
          additionalClasses="xl:px-6 xl:py-3 xl:text-xs 2xl:text-sm 2xl:px-8 2xl:py-4"
          onClick={handleFormSubmit}
          variant={currentStep === 1 ? "magnetiqSolid" : "rustPinkSolid"}
          icon={ArrowRight}
        />
      </div>
    </>
  );
}
